/*
 * @Author: liyihui
 * @Date:
 * @description: 账号权限有关的全局储值
 * @Last Modified by:
 * @Last Modified time:
 */

import { routerMap } from '@/router';

const user = {
	state: {
		roles: [], // 账号权限数组
		rolesStr: '', // 账号权限字符串
		menuList: [], // 菜单上的路由
	},

	// 修改state字段的值的方法，第一个参固定为state，第二个参在外部调用时传入
	mutations: {
		// 设置权限值，储存、更新接口拿到的权限
		SET_ROLES: (state, acquiredRoles) => {
			state.roles = acquiredRoles;
			// 页面v-has校验权限用的str
			let rolesArrey = [];
			acquiredRoles.forEach(element => { rolesArrey.push(element.res_nm); });
			state.rolesStr = rolesArrey.toString();
		},

		// 设置根据权限处理后的菜单
		SET_MENULIST: (state, newRouters) => {
			state.menuList = newRouters;
		},
	},

	// actions用来处理mutations中的异步操作，触发mutations中的函数
	// 从外部调用时 this.$store.dispatch('functionName').then(() => { word });
	actions: {

	},
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js